var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 123.939,
    x2: 123.939,
    y1: 488,
    y2: 45.891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#ef4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#d35959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#a3e441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#84cc16"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 123.878,
    x2: 123.878,
    xlinkHref: "#linear-gradient",
    y1: 488,
    y2: 45.891
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 289.5,
    x2: 289.5,
    xlinkHref: "#linear-gradient",
    y1: 488,
    y2: 45.891
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 289.107,
    x2: 289.107,
    xlinkHref: "#linear-gradient",
    y1: 488,
    y2: 45.891
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 298,
    x2: 298,
    xlinkHref: "#linear-gradient",
    y1: 488,
    y2: 45.891
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m130 189.487v-3.487a20.843 20.843 0 0 0 14.365-19.523 20.475 20.475 0 0 0 -20.457-20.426 8.427 8.427 0 1 1 8.4-8.427 6.031 6.031 0 0 0 12.061 0 20.842 20.842 0 0 0 -14.369-19.524v-2.83a6 6 0 0 0 -12 0v2.83a20.953 20.953 0 0 0 -14.487 19.523 20.423 20.423 0 0 0 20.395 20.427 8.423 8.423 0 0 1 .074 16.846c-.033 0-.067 0-.1 0s-.066 0-.1 0a8.433 8.433 0 0 1 -8.33-8.42 5.97 5.97 0 1 0 -11.94 0c0 9.175 6.487 16.953 14.487 19.523v3.485a6 6 0 0 0 12 0z",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m195.311 152.381a71.433 71.433 0 1 0 -71.433 71.432 71.514 71.514 0 0 0 71.433-71.432zm-130.866 0a59.433 59.433 0 1 1 59.433 59.432 59.5 59.5 0 0 1 -59.433-59.432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.427 152.381a87.549 87.549 0 1 0 -87.549 87.549 87.648 87.648 0 0 0 87.549-87.549zm-163.1 0a75.549 75.549 0 1 1 75.549 75.549 75.635 75.635 0 0 1 -75.547-75.549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.125 271.259a6 6 0 0 0 4.544-2.08l9.982-11.571a108.62 108.62 0 0 0 27.175-.7l10.681 11.137a6 6 0 0 0 6.735 1.344l30.685-13.424a6 6 0 0 0 3.579-5.937l-1.132-15.4a97.912 97.912 0 0 0 18.777-19.714l15.374.452a6.014 6.014 0 0 0 5.774-3.837l12.055-31.229a6 6 0 0 0 -1.677-6.7l-11.568-9.985a108.769 108.769 0 0 0 -.7-27.176l11.136-10.681a6 6 0 0 0 1.345-6.735l-13.428-30.692a5.979 5.979 0 0 0 -5.937-3.578l-15.4 1.131a97.978 97.978 0 0 0 -19.711-18.777l.452-15.374a6 6 0 0 0 -3.838-5.774l-31.233-12.059a6 6 0 0 0 -6.7 1.679l-9.982 11.57a108.8 108.8 0 0 0 -27.18.7l-10.683-11.13a6 6 0 0 0 -6.736-1.344l-30.685 13.425a6 6 0 0 0 -3.579 5.936l1.132 15.4a97.913 97.913 0 0 0 -18.782 19.713l-15.369-.449a5.993 5.993 0 0 0 -5.774 3.837l-12.057 31.23a6 6 0 0 0 1.678 6.7l11.57 9.983a108.672 108.672 0 0 0 .7 27.176l-11.131 10.684a6 6 0 0 0 -1.344 6.735l13.427 30.686a5.973 5.973 0 0 0 5.937 3.578l15.4-1.132a97.907 97.907 0 0 0 19.713 18.777l-.45 15.373a6 6 0 0 0 3.837 5.775l31.233 12.054a5.984 5.984 0 0 0 2.155.403zm-27.356-41.678a86.057 86.057 0 0 1 -21.518-20.493 5.981 5.981 0 0 0 -5.264-2.416l-14.4 1.058-10.042-22.959 10.4-9.976a6 6 0 0 0 1.749-5.41 96.767 96.767 0 0 1 -.773-29.928 6 6 0 0 0 -2.03-5.316l-10.774-9.3 9-23.329 14.386.422a5.983 5.983 0 0 0 5.168-2.668 86.041 86.041 0 0 1 20.499-21.514 6 6 0 0 0 2.417-5.264l-1.058-14.4 22.958-10.04 9.976 10.4a6 6 0 0 0 5.41 1.749 96.712 96.712 0 0 1 29.933-.773 6.006 6.006 0 0 0 5.317-2.031l9.294-10.774 23.329 9-.423 14.386a6 6 0 0 0 2.669 5.169 86.074 86.074 0 0 1 21.518 20.499 5.965 5.965 0 0 0 5.264 2.416l14.4-1.058 10.044 22.958-10.4 9.977a6 6 0 0 0 -1.749 5.41 96.771 96.771 0 0 1 .773 29.928 6 6 0 0 0 2.03 5.315l10.771 9.3-9 23.329-14.386-.423a5.958 5.958 0 0 0 -5.168 2.669 86.084 86.084 0 0 1 -20.494 21.519 6 6 0 0 0 -2.416 5.263l1.058 14.4-22.958 10.043-9.977-10.4a6 6 0 0 0 -5.409-1.75 96.772 96.772 0 0 1 -29.928.774 6 6 0 0 0 -5.317 2.03l-9.304 10.767-23.329-9 .423-14.386a6 6 0 0 0 -2.669-5.173z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m501 443h-13v-180.161a5.957 5.957 0 0 0 -6.106-5.839h-51.153a5.648 5.648 0 0 0 -5.741 5.839v180.161h-49v-232.716a6.094 6.094 0 0 0 -5.813-6.284h-51.153a6.278 6.278 0 0 0 -6.034 6.284v232.716h-49v-127.607c0-3.314-2.207-6.393-5.521-6.393h-51.152a6.633 6.633 0 0 0 -6.327 6.393v127.607h-48v-50.618a6.535 6.535 0 0 0 -6.228-6.382h-51.152c-3.314 0-5.62 3.068-5.62 6.382v50.618h-11.6a6.7 6.7 0 0 0 -6.4 6.4v23.1c0 3.314 3.084 5.5 6.4 5.5h422.6c3.313 0 6-2.188 6-5.5v-23.1c0-3.315-2.687-6.4-6-6.4zm-64-174h39v174h-39zm-112-53h39v227h-39zm-112 105h39v122h-39zm-111 77h39v45h-39zm393 68h-411v-11h411z",
    fill: "url(#linear-gradient-5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m233.253 224.78a32.257 32.257 0 0 0 -29.441 45.48l-59.768 40.673a32.253 32.253 0 1 0 6.9 9.817l59.737-40.65a32.256 32.256 0 0 0 47.344-43.707l65.234-60.571a32.247 32.247 0 0 0 50.1-8.544l53.965 23.805a32.373 32.373 0 1 0 7.134-9.967l-57.458-25.347a32.274 32.274 0 1 0 -61 10.416l-67.334 62.521a32.075 32.075 0 0 0 -15.413-3.926zm-111.707 129.544a20.277 20.277 0 1 1 16.1-32.554l1.254 1.83a20.234 20.234 0 0 1 -17.349 30.72zm335.121-170.1a20.277 20.277 0 1 1 -20.276 20.276 20.3 20.3 0 0 1 20.276-20.273zm-111.707-52.551a20.277 20.277 0 1 1 -20.276 20.276 20.3 20.3 0 0 1 20.276-20.276zm-111.707 145.662a20.278 20.278 0 1 1 20.278-20.277 20.3 20.3 0 0 1 -20.278 20.277z",
    fill: "url(#linear-gradient-6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m304 236.169a6 6 0 1 0 -12 0v2.984a6 6 0 1 0 12 0z",
    fill: "url(#linear-gradient-7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m298 252.463a6 6 0 0 0 -6 6v86.669a6 6 0 1 0 12 0v-86.669a6 6 0 0 0 -6-6z",
    fill: "url(#linear-gradient-7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.1a9f2609365a3e7db7bbe39b698f1573.svg";
export { ForwardRef as ReactComponent };